import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UTCDate } from 'map-wald';

@Component({
  selector: 'app-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.scss']
})
export class MonthPickerComponent implements OnInit, OnChanges {
  @Input() minDate: UTCDate;
  @Input() maxDate: UTCDate;
  @Input() currentDate: UTCDate;
  @Input() selectableYear = true;
  @Input() monthsBefore = 0;
  @Output() currentDateChanged = new EventEmitter<UTCDate>();

  minYear:number;
  maxYear:number;

  atMinYear: boolean;
  atMaxYear: boolean;

  year:number;
  month:number;
  monthName:string;
  months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  monthDisabled: {[key:string]:boolean} = {};
  includedMonth: {[key:string]:boolean} = {};
  monthClasses: {[key:string]:string} = {};
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.currentDate){
      this.initDate();
    } else if(changes.monthsBefore){
      this.highlightTimePeriod();
    }
  }

  ngOnInit(): void {
    this.initDate();
  }

  initDate() {
    this.year = this.currentDate?.getUTCFullYear();
    this.month = this.currentDate?.getUTCMonth();
    this.monthName = this.months[this.month];
    this.evaluateLimits();
    this.highlightTimePeriod();
    this.evaluateButtonClasses();
  }

  evaluateButtonClasses() {
    this.monthClasses = {};
    this.months.forEach(m=>{
      if(m===this.monthName){
        this.monthClasses[m] = 'btn-primary';
      } else if(this.monthDisabled[m]){
        this.monthClasses[m] = 'btn-outline-secondary';
      } else if(this.includedMonth[m]){
        this.monthClasses[m] = 'btn-light-primary';
      } else {
        this.monthClasses[m] = 'btn-secondary';
      }
    });
  }

  monthSelected(month:string,event?:MouseEvent):void{
    let idx = this.months.indexOf(month);
    if(event?.shiftKey){
      idx += this.monthsBefore;
      idx = idx % 12;
    }

    this.month = idx;
    this.monthName = this.months[this.month];

    this.updateDate();
  }

  updateDate() {
    this.currentDate = new Date(Date.UTC(this.year, this.month, 1));
    this.currentDateChanged.emit(this.currentDate);
  }

  // moveYear(offset:number):void{
  //   this.yearChanged(this.year + offset);
  // }

  yearChanged(year:number):void{
    this.year = year;
    this.updateDate();
    this.evaluateLimits();
    this.highlightTimePeriod();
    this.evaluateButtonClasses();
  }

  highlightTimePeriod(): void {
    this.includedMonth = {}
    for(let i=0;i<this.monthsBefore;i++){
      let mth = this.month-i-1;
      if(mth<0){
        mth = 12+mth;
      }
      this.includedMonth[this.months[mth]] = true;
    }
    this.evaluateButtonClasses();
  }

  evaluateLimits() {
    this.minYear = this.minDate?.getUTCFullYear();
    this.maxYear = this.maxDate?.getUTCFullYear();
    this.atMinYear = this.year === this.minYear;
    this.atMaxYear = this.year === this.maxYear;
    this.monthDisabled = {};

    if(this.atMinYear){
      this.months.forEach((m,i)=>{
        if(i<this.minDate.getUTCMonth()){
          this.monthDisabled[m] = true;
        }
      });
    }

    if(this.atMaxYear){
      this.months.forEach((m,i)=>{
        if(i>this.maxDate.getUTCMonth()){
          this.monthDisabled[m] = true;
        }
      });
    }
  }
}
